import { render, staticRenderFns } from "./CatalogueFilters.vue?vue&type=template&id=38d26ce5"
import script from "./CatalogueFilters.vue?vue&type=script&lang=js"
export * from "./CatalogueFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports